/* eslint-disable import/first,no-func-assign */
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';

var SvgCornerDownRight = props => /*#__PURE__*/React.createElement("svg", _extends({}, props, {
  "aria-hidden": !props['aria-label'],
  focusable: "false",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M2.80621 4.82152C2.80621 6.15719 3.88899 7.23997 5.22466 7.23997H9.65848V8.04612L5.22466 8.04612C3.44375 8.04612 2.00006 6.60243 2.00006 4.82152L2.00006 2L2.80621 2L2.80621 4.82152Z"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M7.27457 9.6584L9.28995 7.64303L7.27457 5.62765L7.8446 5.05762L10.43 7.64303L7.8446 10.2284L7.27457 9.6584Z"
}));

export default SvgCornerDownRight;